import { render, staticRenderFns } from "./save-documentation-file-dialog.component.vue?vue&type=template&id=073d6040"
import script from "./save-documentation-file-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-documentation-file-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports